import { use } from 'react'
import { CountriesContext } from './CountriesContext'

export function useCountriesContext() {
  const context = use(CountriesContext)

  if (!context) {
    throw new Error('useCountriesContext must be used within a CountriesProvider')
  }

  return context
}
